import React, { useState } from 'react';
import CheckAuth from '../../elements/checkAuth';
import axios from 'axios';
import config from '../../../../config/environment';
import Menu from '../../elements/Menu/menu';
import './sumSubStatus.css';

export default function SumSubStatus() {
    const [state, setState] = useState({
        userId: null,
        sumSubData: null
    });

    const renderControl = () => {
        return(
            <div className="orderInfo__control_wrapper">
                <div className="orderInfo__control">
                    <input value={ state.userId || '' } type="text" placeholder="email / token / link / ETH address"
                        className="sumSubStatus__controlInput" onChange={event => setState({ ...state, userId: event.target.value })}/>
                    <button onClick={controlButtonHandler} >Get</button>
                </div>
            </div>
        )
    };

    const controlButtonHandler = async () => {
        if (!state.userId) {
            alert('Invalid userId');
            return;
        }

        await axios.get(config.backendUrl + '/sum-sub/status-for-admin?userId=' + state.userId,
            { headers: { 'Authorization': 'Bearer '+ localStorage.getItem('jwtToken') } })
        .then(response => {
            setState(state => { return { ...state, sumSubData: response.data } });
            console.log(response.data); // todo:
        })
        .catch(error => {
            console.log(error.response ? error.response.data : error.message);
            alert(error.message);
        });
    };

    const updateStatusHandler = async () => {
        if (!state.userId) {
            alert('Invalid userId');
            return;
        }

        await axios.get(config.backendUrl + '/sum-sub/update-status-for-admin?userId=' + state.userId,
            { headers: { 'Authorization': 'Bearer '+ localStorage.getItem('jwtToken') } })
        .then(response => {
            alert(response.data.result);
        })
        .catch(error => {
            console.log(error.response ? error.response.data : error.message);
            alert(error.message);
        });
    };

    const renderData = () => {
        if (!state.sumSubData) { return; }

        return(
            <div className="sumSubStatus__info_wrapper">
                <div className="sumSubStatus__infoTitle">Basic info</div>
                <div><b>Email: </b>{ state.sumSubData.userId || '[No data]' }</div>
                <div><b>Applicant ID (SumSub ID): </b>{ state.sumSubData.applicantId || '[No data]' }</div>
                <div><b>Trustee user ID (hash): </b>{ state.sumSubData.trusteeUserId || '[No data]' }</div>
                <div><b>Review status: </b>{ state.sumSubData.reviewStatus || '[No data]' }</div>
                <div><b>Review answer: </b>{ state.sumSubData.reviewAnswer || '[No data]' }</div>
                <div><b>Review reject type: </b>{ state.sumSubData.reviewRejectType || '[No data]' }</div>
                <div><b>Reject labels: </b>{ state.sumSubData.rejectLabels ? state.sumSubData.rejectLabels.map(label => label + ', ') :
                    '[No data]' }</div>
                <hr />

                <div className="sumSubStatus__infoTitle">UserData info</div>
                {
                    state.sumSubData.userData ?
                        <>
                            <div><b>Cashback token: </b>{ state.sumSubData.userData.cashbackToken }</div>
                        </>
                        : <div>[No data]</div>
                }
                <hr />

                <button onClick={ updateStatusHandler }>Update status</button>
            </div>
        );
    };

    return(
        <>
            <CheckAuth />
            <Menu />
            <div className="sumSubStatus__wrapper">
                { renderControl() }
                { renderData() }
            </div>
        </>
    );
};
